export default "__VITE_ASSET__VXKzuESx__"